<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.labResults', 2) }}
                    </h3>
                </div>
            </div>

            <div class="card-body p-0">
<!--                <div class="card-title">-->
<!--                    <router-link :to="{ name: 'add-lab-result' }">-->
<!--                        {{ $t('message.add') }}-->

<!--                        <i class="fas fa-plus-circle edit-icon"></i>-->
<!--                    </router-link>-->
<!--                </div>-->

                <template v-if="rows">

                    <b-container class="p-0">
                        <b-row class="justify-content-sm-center">
                            <b-col col sm="6">
                                <b-form-group>
                                    <autocomplete
                                            ref="autocomplete"
                                            :placeholder="$t('message.search')"
                                            :source="mResults"
                                            input-class="form-control"
                                            results-property="data"
                                            :results-display="formattedDisplay"
                                            @selected="itemSelected"
                                    ></autocomplete>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-container>

                    <b-table
                            id="results-table"
                            primary-key="id"
                            :per-page="perPage"
                            :current-page="currentPage"
                            selectable
                            select-mode="single"
                            borderless
                            responsive
                            striped
                            hover
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            @row-selected="rowSelected"
                            :fields="fields"
                            :items="mResults"
                    >
                        <!-- A virtual composite column for actions -->
                        <template slot="action" slot-scope="data">
                            <div class="row">
                                <div class="col-sm-6">
                                    <b-link :to="{ name: 'edit-lab-result', params: { result: data.item.slug } }">
                                        <i class="fas fa-edit fa-2x edit-icon"></i>
                                    </b-link>
                                </div>

                                <div class="col-sm-6">
                                    <i v-b-modal="'delete-modal-' + data.item.slug" class="fas fa-trash fa-2x delete-icon"></i>
                                </div>
                            </div>

                            <b-modal
                                    :id="'delete-modal-' + data.item.slug"
                                    size="sm"
                                    header-bg-variant="danger"
                                    header-text-variant="light"
                                    :title="$t('message.delete') + ' ' + $tc('message.labResults', 1)"
                                    hide-footer
                            >
                                <div class="d-block text-center">
                                    <h3>{{ $t('message.delete') }}?</h3>
                                </div>

                                <div class="d-block float-right">
                                    <b-button class="secondary" @click="deleteResult(data.item.slug)">
                                        {{ $t('message.delete') }}
                                    </b-button>

                                    <b-button class="danger" @click="$bvModal.hide('delete-modal-' + data.item.slug)">
                                        {{ $t('message.cancel') }}
                                    </b-button>
                                </div>
                            </b-modal>
                        </template>
                    </b-table>

                    <b-pagination
                            class="justify-content-center"
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="results-table"
                    ></b-pagination>
                </template>

                <template v-else>
                    <div class="card">
                        <div class="card-body text-xs-center">
                            <p class="card-text">
                                {{ $t('message.noResults') }}
                            </p>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import _ from 'lodash';

    export default {
        name: "Resultats",

        computed: {
            ...mapGetters(["results"]),

            mResults: function() {
                let rArray = [];

                _.forEach(this.results, function(result) {
                    let r = {};

                    r.description = result.description.length > 20 ? result.description.substr(0, 20) + '...' : result.description;
                    r.date = moment(result.date).format('YYYY/MM/DD HH:mm');
                    r.id = result.id;
                    r.slug = result.slug;

                    rArray.push(r);
                });

                return rArray;
            },

            rows: function() {
                return this.mResults.length;
            }
        },

        data() {
            return {
                perPage: 10,
                currentPage: 1,
                sortBy: 'date',
                sortDesc: true,
                fields: [
                    {
                        key: 'description',
                        label: this.$i18n.t('message.description'),
                    },
                    {
                        key: 'date',
                        label: this.$i18n.tc('message.dates', 1),
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: this.$i18n.tc('message.operations', 1)
                    }
                ],
                offset: 0,
                limit: -1,
            }
        },

        methods: {
            getResults() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getLabResults', { args : args });
            },

            formattedDisplay (result) {
                return result.description.length > 10 ? result.description.substr(0, 10) + '...' : result.description;
            },

            rowSelected(items) {
                this.$router.push({ name: 'lab-result', params: { result: items[0].slug } });
            },

            itemSelected(item) {
                this.$router.push({ name: 'lab-result', params: { result: item.selectedObject.slug } });
            },

            deleteResult(result) {
                let self = this;

                let args = {
                    result: result
                };

                let successMessage = this.$i18n.t('message.resultDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteLabResult', { args, index: result, successMessage, errorMessages })
                    .then(() => {
                        self.$bvModal.hide('delete-modal-' + result);
                    });
            }
        },

        mounted() {
            // Fetch result list
            this.getResults();
        }
    }
</script>

<style scoped>

</style>